module.exports = __webpack_public_path__ + "img/nature9.2fb539f6.jpg";